import { Component } from 'react';
import SuspenseError from './SuspenseError.js';
export default class ErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            error: null,
        };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, info) {
        const { onErrorCaught } = this.props;
        if (onErrorCaught) {
            onErrorCaught(error instanceof SuspenseError ? error.cause : error, info);
        }
    }
    render() {
        const { children } = this.props;
        const { error } = this.state;
        return error ? this.renderError(error) : children;
    }
    renderError(error) {
        const { renderError, onExpireResource } = this.props;
        const recover = () => {
            if (error instanceof SuspenseError) {
                onExpireResource === null || onExpireResource === void 0 ? void 0 : onExpireResource(error.action, error.params);
            }
            this.setState({ error: null });
        };
        return renderError(error instanceof SuspenseError ? error.cause : error, { recover });
    }
}
//# sourceMappingURL=ErrorBoundary.js.map